import { translate } from '../../../../i18n';
import { isCountryWithZip } from '../../parcel-creation/delivery-details-form/delivery-details-form.component';

export const getMaxValidation = (
  value: number | undefined,
  configValue?: number
) => {
  if (!value) return false;
  if (!configValue) return true;
  return value <= configValue;
};

export const getMinValidation = (
  value: number | undefined,
  configValue: number = 0
) => {
  if (!value) return false;
  if (value === 0) return false;
  if (!configValue) return true;
  return value >= configValue;
};

export const getRouteFieldLabel = (countryCode: string | undefined): string => {
  if (isCountryWithZip(countryCode))
    return translate('domestic_calculator_placeholder_zip_city');

  return `${translate('domestic_calculator_placeholder_postalcode_city')}`;
};
